import PropTypes from 'prop-types';

/* eslint-disable import/prefer-default-export */
export const createContainer = (typeName: any) => {
  const Container = (props: any) => props.children;
  Container.propTypes = { children: PropTypes.element.isRequired };
  Container.typeName = typeName;
  return Container;
};
